import { trackButtonClick } from "@/utils/analytics";
import { markInternalNavigation } from "@/utils/attributionCapture";
import "../home/FilterCards.css";

const HubzuSarchVariety = ({ style = "", data }) => {
  const cmsData = data?.searchPropertyNewHome;

  const content = [
    {
      id: 1,
      icon: "/assets/svg/home/Residential_Properties.svg",
      title: cmsData?.residentialProperties?.title,
      description: cmsData?.residentialProperties?.desc,
      buttonText: cmsData?.residentialProperties?.btnText,
      redirectionUrl: cmsData?.residentialProperties?.redirectionUrl,
    },
    {
      id: 2,
      icon: "/assets/svg/home/Banked_Owned.svg",
      title: cmsData?.bankOwned?.title,
      description: cmsData?.bankOwned?.desc,
      buttonText: cmsData?.bankOwned?.btnText,
      redirectionUrl: cmsData?.bankOwned?.redirectionUrl,
    },
    {
      id: 3,
      icon: "/assets/svg/home/Foreclosure_Auction.svg",
      title: cmsData?.Foreclosure?.title,
      description: cmsData?.Foreclosure?.desc,
      buttonText: cmsData?.Foreclosure?.btnText,
      redirectionUrl: cmsData?.Foreclosure?.redirectionUrl,
    },
    {
      id: 4,
      icon: "/assets/svg/home/High_End_Auction.svg",
      title: cmsData?.highEndAuctions?.title,
      description: cmsData?.highEndAuctions?.desc,
      buttonText: cmsData?.highEndAuctions?.btnText,
      redirectionUrl: cmsData?.highEndAuctions?.redirectionUrl,
    },
  ];

  return (
    <div className="search-container-home px-2 py-4">
      <div className=" mx-0  ">
        <div className="row">
          {content.map((option) => (
            <div
              className="col-xl-3 col-lg-6 col-md-6 col-12  mb-3"
              key={option.id}
            >
              <div className="card sell-card h-md-100">
                <div className="card-body d-flex flex-column text-center">
                  <div className="sell-card-icon mb-3 mt-3">
                    <img
                      src={option.icon}
                      alt={
                        option.title || `Property search option ${option.id}`
                      }
                      className="search-card-icon-img"
                    />
                  </div>

                  <h3 className="sell-card-title mb-3">
                    {option.title || `Property Search Option ${option.id}`}
                  </h3>
                  <p className="card-text sell-card-description flex-grow-1 mb-4">
                    {option.description}
                  </p>
                  <button
                    id={`search-variety-btn-${option.id}`}
                    type="button"
                    className="btn sell-card-btn"
                    aria-label={`Search ${option.title}`}
                    onClick={() => {
                      trackButtonClick({
                        eventName: "filter_card_click",
                        eventCategory: "click",
                        eventSource: "Home Page 2.0",
                        eventLabel: `${
                          option.class === "foreclosure"
                            ? "Foreclosure Properties"
                            : option.class === "bankowned"
                              ? "Bankowned Properties"
                              : option.class === "Auction"
                                ? "Auction Properties"
                                : "Signature Seller Properties"
                        }`,
                        eventParams: {
                          filter_type:
                            option.class === "foreclosure"
                              ? "foreclosure"
                              : option.class === "bankowned"
                                ? "bankowned"
                                : option.class === "Auction"
                                  ? "auction"
                                  : "signature_seller",
                        },
                      });
                      markInternalNavigation();
                      window.open(option.redirectionUrl);
                    }}
                  >
                    {option.buttonText}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HubzuSarchVariety;
